module.exports = "../fonts/Futura-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./@fonts/futura/Futura-Regular.woff2
// module id = 511
// module chunks = 7